import React from "react";
import { Chip } from "@mantine/core";

interface BadgeChipProps {
  label: string;
}

const BadgeChip = ({ label }: BadgeChipProps) => {
  return (
    <div>
      <Chip>{label}</Chip>
    </div>
  );
};

export default BadgeChip;
